import React from 'react'
import snakeImg from './assets/snake.png'
import './styles.scss'

const Snakes = () => {
  return (
    <div className="absolute snakes-container">
      <div className="snakes absolute">
        <img
          src={snakeImg}
          className="snake left"
          onClick={() => {
            alert('🐍 esssssskewsssss you 🐍')
          }}
        />
        <img
          src={snakeImg}
          className="snake right"
          onClick={() => {
            alert('🐍 oh ssssssssssssnap 🐍')
          }}
        />
      </div>
    </div>
  )
}

export default Snakes
